import React from 'react';
import { TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function FromUncertainty() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-189" data-mp="20zpgq0h2t1p2">
      <div className="mx-auto max-w-3xl px-4" data-id="element-190" data-mp="210hcpcel51fv">
        <SectionHeading title="From Uncertainty to a Structured Third Molar Assessment" data-id="element-191" data-mp="1wynhvkr2mrnm" />
        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85" data-id="element-192" data-mp="2tomy81dgqugr">
          <p data-id="element-193" data-mp="2tqr4ur2qy7kq">
            You may already understand third molar anatomy, clinical examination, radiographic interpretation, surgical indications, and
            potential complications.
          </p>
          <p data-id="element-194" data-mp="2jwgww11bn0ow">But knowing these concepts individually doesn’t always make it easy to organize them when evaluating a specific case.</p>
          <p className="font-display text-2xl font-bold leading-snug text-ink" data-id="element-195" data-mp="3cfnz4uy5902y">
            That’s exactly why I created Third Molar Assessment Blueprint™.
          </p>
          <p data-id="element-196" data-mp="37ml40idpxikn">
            I wanted to develop a practical visual framework that helps you bring the essential parts of a third molar assessment together
            in one organized system.
          </p>
          <p data-id="element-197" data-mp="g0l0k2cc2fyt">
            Instead of repeatedly switching between textbooks, lecture notes, and disconnected references, you’ll have a structured
            educational roadmap to help you organize the available information, identify what still needs to be evaluated, and document
            the questions that require further consideration.
          </p>
        </div>

        <div className="mt-8 rounded-2xl bg-accentSoft p-6 sm:p-8" data-id="element-198" data-mp="c0avcrwd7tl0">
          <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-accent" data-id="element-199" data-mp="3t868etxna172">
            <TargetIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="21l9yp59fr00" /> My goal is simple
          </p>
          <p className="mt-3 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-201" data-mp="1rgt343rrlrah">
            Help you structure an initial third molar assessment in approximately 15 minutes when the necessary information is available.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-202" data-mp="1uvb86prmxxqg">
            This is a target for organizing information—not a promise of a complete examination, definitive diagnosis, or surgical
            treatment plan in 15 minutes.
          </p>
        </div>

        <p className="mt-6 text-center text-[17px] font-semibold text-ink" data-id="element-203" data-mp="1gzh72sx3scnw">
          Third Molar Assessment Blueprint™ is designed to support your clinical reasoning, not replace your professional judgment.
        </p>

        <div className="mt-10" data-id="element-204" data-mp="28r5d6xpag2ya">
          <CtaButton label="I Want a Clearer Third Molar Assessment Framework" data-id="element-205" data-mp="23xu5kucnji5b" />
        </div>
      </div>
    </section>;
}